// Side-effect import must run first: App's module graph is hoisted below and
// evaluates before any inline Sentry.init would in this file's body, so a
// module-eval-time throw in App could escape capture otherwise.
import './utils/sentryInit'
import * as Sentry from '@sentry/react'
import ReactDOM from 'react-dom/client'
import { SpeedInsights } from '@vercel/speed-insights/react'
import '@fontsource/fjalla-one/400.css'
import '@fontsource-variable/source-sans-3'
import './overlay.css'
import App from './App.tsx'

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- index.html defines a literal `<div id='root'>` that this Vite entry always loads against, so the element is always present.
ReactDOM.createRoot(document.getElementById('root')!, {
  // React 19 error hooks — captures errors outside any boundary (overlay has
  // no ErrorBoundary today).
  onCaughtError: Sentry.reactErrorHandler(),
  onUncaughtError: Sentry.reactErrorHandler(),
}).render(
  <>
    <App />
    <SpeedInsights />
  </>,
)
